var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper reg-link-wrap"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0), _c('div', {
    staticClass: "bg-white"
  }, [_vm._m(1), _c('div', {
    staticClass: "clientsData-wrap"
  }, [_c('div', {
    staticClass: "top-pagination"
  }), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _c('tbody', [_vm.exportLogs.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No Export logs found")])]) : _vm._e(), _vm._l(_vm.exportLogs, function (log) {
    var _log$completed_at;

    return _c('tr', {
      key: log.id
    }, [_c('td', [_vm._v(_vm._s(log.file_name))]), _c('td', [_vm._v(" " + _vm._s(log.file_path) + " ")]), _c('td', [_vm._v(" " + _vm._s(log.started_at) + " ")]), _c('td', [_vm._v(_vm._s((_log$completed_at = log.completed_at) !== null && _log$completed_at !== void 0 ? _log$completed_at : "Pending"))]), _c('td', [_vm._v(_vm._s(log.exported_by))]), _c('td', [_vm._v(_vm._s(log.status))]), _c('td', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "d-flex gap-2"
    }, [_c('div', {
      staticClass: "mr-2"
    }, [log.status === 'completed' && log.download_url ? _c('b-button', {
      staticClass: "p-0 text-decoration-none d-flex align-items-center gap-1",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.downloadFile(log.download_url);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-download"
    }), _vm._v(" Download ")]) : _c('div', [_vm._v("NA")])], 1)])])]);
  })], 2)])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title emp-grp-title"
  }, [_c('div', {
    staticClass: "grp-title"
  }, [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Export Logs")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-wrap search-options gap-3 mb-3"
  }, [_c('div', {}), _c('div', {})]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Name")]), _c('th', [_vm._v("Path")]), _c('th', [_vm._v("Started At")]), _c('th', [_vm._v("Completed At")]), _c('th', [_vm._v("Generated By")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Download")])])]);
}]

export { render, staticRenderFns }